/* Kolsyra announcement bar - mobile auto-rotation.
 * Desktop (>=768px): all messages visible at once, no JS-driven animation.
 * Mobile (<768px): cycles through messages every 4s with CSS fade.
 * Respects prefers-reduced-motion (no rotation, shows first message). */
(function () {
  'use strict';

  const list = document.querySelector('.k-announcement__list');
  if (!list) return;

  const items = list.querySelectorAll('.k-announcement__item');
  if (items.length < 2) return;

  const MOBILE_MQ = '(max-width: 767px)';
  const REDUCE_MQ = '(prefers-reduced-motion: reduce)';
  const INTERVAL = 4000;

  let timer = null;
  let active = 0;

  function activate(i) {
    items.forEach((el, idx) => el.classList.toggle('is-active', idx === i));
    active = i;
  }

  function tick() {
    activate((active + 1) % items.length);
  }

  function start() {
    if (timer) return;
    if (window.matchMedia(REDUCE_MQ).matches) {
      activate(0);
      return;
    }
    activate(0);
    timer = setInterval(tick, INTERVAL);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    items.forEach((el) => el.classList.remove('is-active'));
  }

  const mq = window.matchMedia(MOBILE_MQ);

  function evaluate() {
    if (mq.matches) start();
    else stop();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', evaluate);
  } else if (mq.addListener) {
    // Safari < 14 fallback
    mq.addListener(evaluate);
  }

  evaluate();
})();
